export function buildMailto(v) {
    const to = v.to || "";
    const params = [];
    if (v.subject) params.push(`subject=${encodeURIComponent(v.subject)}`);
    if (v.body) params.push(`body=${encodeURIComponent(v.body)}`);
    const suffix = params.length ? `?${params.join("&")}` : "";
    return `mailto:${to}${suffix}`;
}

export function buildVCard(v) {
    const lines = ["BEGIN:VCARD", "VERSION:3.0"];
    const first = v.firstName || "";
    const last = v.lastName || "";
    lines.push(`N:${last};${first};;;`);
    const fn = `${first} ${last}`.trim();
    if (fn) lines.push(`FN:${fn}`);
    if (v.org) lines.push(`ORG:${v.org}`);
    if (v.title) lines.push(`TITLE:${v.title}`);
    if (v.phone) lines.push(`TEL;TYPE=CELL:${v.phone}`);
    if (v.email) lines.push(`EMAIL:${v.email}`);
    if (v.website) lines.push(`URL:${v.website}`);
    const address = [v.street, v.city, v.state, v.zip, v.country].filter(
        Boolean,
    );
    if (address.length) {
        const formatted = `ADR:;;${v.street || ""};${v.city || ""};${v.state || ""};${v.zip || ""};${v.country || ""}`;
        lines.push(formatted);
    }
    lines.push("END:VCARD");
    return lines.join("\n");
}

function formatICalDate(dateValue) {
    if (!dateValue) return "";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return "";
    const pad = (num) => String(num).padStart(2, "0");
    return (
        date.getFullYear() +
        pad(date.getMonth() + 1) +
        pad(date.getDate()) +
        "T" +
        pad(date.getHours()) +
        pad(date.getMinutes()) +
        pad(date.getSeconds())
    );
}

export function buildICal(v) {
    const lines = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//QR & Barcode Toolkit//EN",
        "BEGIN:VEVENT",
    ];
    if (v.title) lines.push(`SUMMARY:${v.title}`);
    const start = formatICalDate(v.start);
    const end = formatICalDate(v.end);
    if (start) lines.push(`DTSTART:${start}`);
    if (end) lines.push(`DTEND:${end}`);
    if (v.location) lines.push(`LOCATION:${v.location}`);
    if (v.description) lines.push(`DESCRIPTION:${v.description}`);
    lines.push("END:VEVENT", "END:VCALENDAR");
    return lines.join("\n");
}
